<upp-guest-ticket-preview *ngIf="ShowTicket" uppDataid="guestcounter-ticket-preview"
    [ticket]="ShowTicket"
    color="warning"
    (Done)="OnShowTicket(null)"
></upp-guest-ticket-preview>

<ng-container *ngIf="ShowTicket === null">
    <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'">
        <div class="body">
            <ion-card>
                <ion-icon color="warning" name="walk"></ion-icon>
                <ion-card-title color="warning">
                    {{ tr('@place_nowaiter_requested_title') }}
                </ion-card-title>
                <ion-card-content>
                    {{ tr('@place_nowaiter_requested_message') }}
                </ion-card-content>
            </ion-card>

            <ion-list class="ticketinfo">
                <ng-container *ngFor="let request of TicketRequests; trackBy: RequestTrack">
                    <upp-guest-ticket-thumb *ngIf="request.ticket as ticket"
                        uppDataid="guestcounter-show-ticket"
                        [ticket]="ticket"
                        mode="PENDING"
                        [reason]="request.reason"
                        [amount]="request.reason === 'REFUND' ? request.amount : null"
                        (Open)="OnShowTicket($event)">
                    </upp-guest-ticket-thumb>
                </ng-container>
            </ion-list>

            <ng-container *ngIf="PayAmount">
                <ion-item class="action" lines="none">
                    <ng-container *ngIf="PayAmount.Neg !== true">
                        <ion-label>
                            {{ tr('@place_nowaiter_payment_pending_title') }}<br/>
                            <span class="small" *ngIf="PayMethod === 'PAYCASH'">{{ tr('@place_nowaiter_payment_pending_cash') }}</span>
                            <span class="small" *ngIf="PayMethod === 'PAYCARD'">{{ tr('@place_nowaiter_payment_pending_card') }}</span>
                        </ion-label>
                        <ion-label class="amount" slot="end">
                            {{ PayAmount.Int }}<span class="decimal">,{{ PayAmount.Dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ng-container>
                    <ng-container *ngIf="PayAmount.Neg === true">
                        <ion-icon slot="start" name="undo"></ion-icon>
                        <ion-label>
                            {{ tr('@place_nowaiter_refund_pending_title') }}<br/>
                            <span class="small">{{ tr('@place_nowaiter_refund_pending_message') }}</span>
                        </ion-label>
                        <ion-label class="amount" slot="end">
                            {{ PayAmount.Int }}<span class="decimal">,{{ PayAmount.Dec }}</span>{{ tr('@currency') }}
                        </ion-label>
                    </ng-container>
                </ion-item>
            </ng-container>
        </div>
        <div class="list-spacer"></div>
        <div class="form-buttons">
            <ion-button uppDataid="guestcounter-cancel-button" color="warning" size="large" expand="block" (click)="OnCancel()">
                {{ tr('@place_nowaiter_request_cancel') }}
            </ion-button>
            <ion-button uppDataid="guestcounter-close-button" color="warning" size="large" expand="block" fill="clear" (click)="OnClose()">
                {{ tr('@place_nowaiter_request_close') }}
            </ion-button>
        </div>
    </upp-scrollable>
</ng-container>
